import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, UntypedFormBuilder, ValidationErrors, ValidatorFn, FormArray, AbstractControl } from '@angular/forms';
import { FunctionsService } from "../../../../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../../api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AppConstants } from '../../../../app.constants';
import { StripeCardComponent, Element as StripeElement, ElementOptions, ElementsOptions } from "@nomadreservations/ngx-stripe";
import { NgxSpinnerService } from 'ngx-spinner';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
    selector: 'app-edit-card',
    templateUrl: './edit-card.component.html'
})

export class EditCardComponent implements OnInit {
    @ViewChild(StripeCardComponent) card: StripeCardComponent;
    error: any;
    complete = false;
    element: StripeElement;
    model = { options: 'M' };
   
    cardOptions: ElementOptions = {
        style: {
            base: {
                iconColor: '#276fd3',
                color: '#31325F',
                lineHeight: '40px',
                fontWeight: 300,
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSize: '18px',
                '::placeholder': {
                color: '#CFD7E0'
                }
            },
            invalid: {
                color: '#C12127',
                iconColor: '#C12127'
            }
        }
    };
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';

    elementsOptions: ElementsOptions = {
        locale: localStorage.getItem('language')=="es"?'es':'en'
    };

    formSubmitted: boolean = false;
   
    cardId:any;
    cardInfo:any;
    email:any;
    loading = false;
    confirmation;

    submitted = false;
    formProcess = false;
    message = "";
    editCardForm = this.formBuilder.group({
        name: ['', [Validators.required, Validators.maxLength(26), Validators.pattern(AppConstants.cardNameRegex)]],
        address_line1: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(AppConstants.addressRegex)]],
        address_city: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        address_state: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        address_country: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(AppConstants.addressRegex)]],
        address_zip: ['', [Validators.required, Validators.maxLength(5), Validators.pattern(AppConstants.numberRegex)]],
        exp_month: ['', [Validators.required, Validators.maxLength(2), Validators.pattern(AppConstants.monthRegex), validator]],
        exp_year: ['', [Validators.required, Validators.maxLength(4), Validators.pattern(AppConstants.numberRegex), validator]],
        last4: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(AppConstants.numberRegex)]],
    }, {
        validator: validator("exp_month", "exp_year")
    });

    constructor(
        private apiService: ApiService,
        private formBuilder: UntypedFormBuilder,
        public functionsService:FunctionsService, 
        public router: Router, 
        private translate: TranslateService,
        private spinner: NgxSpinnerService,
        private breadcrumbService: BreadcrumbService,
        private route: ActivatedRoute){
            translate.setDefaultLang('en');
            this.functionsService.setTitle('account.edit-card');
            this.functionsService = functionsService;
            this.route.params.subscribe(params => {
                this.cardId = params['cardId'];
            });
        } 

    ngOnInit(){
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguageRed(localStorage.getItem('language'));
        }
        this.translate.onLangChange.subscribe(() => {
            if(this.error){
                this.error["message"] = "";
            }
            this.elementsOptions = {
                locale: (localStorage.getItem('language')=='es')?'es':'en'
            };
        });
        this.breadcrumbService.set('edit-card', 'Edit Card');
        this.spinner.show();
        this.getCard();
    }

    getCard(){
        this.apiService.getCard(this.cardId).subscribe(
            data => {
                this.editCardForm.patchValue(data);
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    editCard(){
        document.getElementById("external_error").innerHTML = "";
  
        if (!this.editCardForm.valid) {
            this.formSubmitted = true;
            return;
        }
        this.spinner.show();
        Object.keys(this.editCardForm.controls).forEach((key)=>{
          this.editCardForm.value[key] = this.editCardForm.value[key]?this.editCardForm.value[key].toString().trim():"";})
        this.editCardForm.value['id'] = this.cardId;
        this.apiService.updateCard(this.editCardForm.value).subscribe(
            () => {
                this.spinner.hide();
                this.cancelEdit();
            },
            error => {
                document.getElementById("external_error").innerHTML = this.translate.instant(error["error"]["content"]);
                this.translate.onLangChange.subscribe(() => {
                    document.getElementById("external_error").innerHTML = this.translate.instant(error["error"]["content"]);
                });
                this.spinner.hide();
            }
        );
    }

    controlGetter(controlName) {
        const control =  this.editCardForm.get(controlName);
        return control && (control.touched || this.formSubmitted) ? control : {};
    }

    cancelEdit(){
        this.router.navigate(['../../'], { relativeTo: this.route });
    }
    
    get name() { return this.controlGetter('name'); }
    get address_line1() { return this.controlGetter('address_line1'); }
    get address_city() { return this.controlGetter('address_city'); }
    get address_state() { return this.controlGetter('address_state'); }
    get address_country() { return this.controlGetter('address_country'); }
    get address_zip() { return this.controlGetter('address_zip'); }
    get exp_month() { return this.controlGetter('exp_month'); }
    get exp_year() { return this.controlGetter('exp_year'); }
    get last4() { return this.controlGetter('last4'); }
}

export const validator = (m,y): ValidatorFn => (control: AbstractControl) => {
    if(control.get(m).value && control.get(y).value){
        var exp_month = Number(control.get(m).value);
        var exp_year = Number(control.get(y).value);
        const expiry = new Date(exp_year, exp_month);
        const current = new Date();
        if(!expiry.getTime() || (expiry.getTime() < current.getTime())){
            if(expiry.getTime() < current.getTime() && (control.get(m).value!="") && (control.get(y).value!="")){
                return { validator: false } 
            }
        }
    }
    return null;
};